// JsFromRoutes CacheKey 91b31ab9c794875ea89740add0825407
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/brokers/workflows'),
  brokers: /* #__PURE__ */ definePathHelper('get', '/brokers/workflows/*path'),
}
